import Join from "./pages/join/join";
import ListCandidates from "./pages/list-candidates/list-candidates";
import JoinSuccess from "./pages/join-success/join-success";

const Candidate = { Join, ListCandidates, JoinSuccess };

export default Candidate;
